import { FC } from 'react';
import { makeStyles } from '@mui/styles';
import { IconButton, List, ListItem, ListItemText, Box, Theme } from '@mui/material';
import { ManyFilesUpload } from '../../../../components';
import { DeleteForever } from '@mui/icons-material';

interface ITodoUpload {
  files?: File[];
  setFiles: (val: File[]) => void;
  uploadText: string;
}

export const TodoUpload: FC<ITodoUpload> = ({ files, setFiles, uploadText }) => {
  const classes = useStyles();
  return (
    <Box className={classes.wrapper}>
      <Box paddingRight="24px">
        <ManyFilesUpload
          imageKey={uploadText}
          uploadText={uploadText}
          accept="image/*"
          handleFileChange={(uploadFiles: File[]) => {
            setFiles([...uploadFiles, ...files]);
          }}
        />
      </Box>
      {files?.length > 0 && (
        <Box className={classes.listWrapper}>
          <List>
            {files.map((file: File, index) => {
              return (
                <ListItem
                  key={`${index}`}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => {
                        const confirm = window.confirm(
                          'Are you sure you want to remove this file?'
                        );

                        if (confirm) {
                          setFiles(files.filter((f, i) => i !== index));
                        }
                      }}
                    >
                      <DeleteForever color="error" />
                    </IconButton>
                  }
                >
                  <ListItemText primary={file.name} />
                </ListItem>
              );
            })}
          </List>
        </Box>
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    },
    '@media print': {
      display: 'block'
    }
  },
  listWrapper: {
    borderTop: `2px solid ${theme.palette.secondary.main}`,
    [theme.breakpoints.up('md')]: {
      paddingLeft: '24px',
      borderLeft: `2px solid ${theme.palette.secondary.main}`,
      borderTop: 'none'
    }
  }
}));
